import axios from 'axios';
import { toast } from 'react-toastify';
import { getAccessToken, removeTokens, getRefreshToken } from './auth';

// Use relative URL in production (Nginx will proxy to backend)
// Use localhost in development
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:8001/api');
// Backend Django sur le port 8001, Frontend React sur le port 3000

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs 401 (non authentifié)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Si erreur 401 et pas déjà tenté de rafraîchir
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = getRefreshToken();
        if (refreshToken) {
          // Tenter de rafraîchir le token
          const response = await axios.post(`${API_BASE_URL}/token/refresh/`, {
            refresh: refreshToken,
          });

          const { access } = response.data;
          localStorage.setItem('access_token', access);

          // Réessayer la requête originale avec le nouveau token
          originalRequest.headers.Authorization = `Bearer ${access}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Si le refresh échoue, déconnecter l'utilisateur
        removeTokens();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    // Affichage toast d'erreur générique (éviter doublons si des toasts spécifiques existent déjà)
    const message =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      'Une erreur est survenue. Veuillez réessayer.';
    // Afficher uniquement pour les erreurs côté client/serveur (>=400), ignorer annulations
    if (!axios.isCancel(error) && (error.response?.status || 0) >= 400) {
      toast.error(message, { position: 'bottom-right', autoClose: 5000 });
    }
    return Promise.reject(error);
  }
);

export default api;

